import React from 'react';
import {
  Card as MuiCard,
  Grid as MuiGrid,
  MenuItem as MuiMenuItem,
  Select as MuiSelect,
} from '@mui/material';
import { withStyles } from '@mui/styles';

import { useFormContext } from 'react-hook-form';

import { withFormController } from '../../../../components/hocs/forms';
import { TextFieldBase } from '../../../../components/inputs/TextFieldBase';
import { InputLabelBase as InputLabel } from '../../../../components/inputs/InputLabelBase';

import { useCardStyles } from './ClaimModalStyles';

const TextField = withFormController(TextFieldBase);

export const CreateClaimOther = withStyles(({ palette }) => ({
  heading: {
    marginTop: 0,
    marginBottom: 25,
    color: palette.common.cowbellBlue,
    textAlign: 'center',
  },
}))(({ classes }) => {
  const cardStyles = useCardStyles();
  const { control, getValues, register, onSelect } = useFormContext();

  return (
    <MuiCard classes={cardStyles}>
      <h2 className={classes.heading}>Other Information</h2>
      <MuiGrid container spacing={1}>
        <MuiGrid item md={6}>
          <InputLabel inline htmlFor="isBusinessImpacted">
            Is your ability to do business impacted?:
          </InputLabel>
        </MuiGrid>
        <MuiGrid item md={6}>
          <MuiSelect
            variant="standard"
            name="isBusinessImpacted"
            {...register('isBusinessImpacted')}
            onChange={onSelect}
            defaultValue={getValues().isBusinessImpacted}
          >
            {yesNoOptions.map(({ label, value }) => (
              <MuiMenuItem key={label} value={value}>
                {label}
              </MuiMenuItem>
            ))}
          </MuiSelect>
        </MuiGrid>

        <MuiGrid item md={6}>
          <InputLabel inline htmlFor="isCyberIncident">
            Is the cyber incident ongoing?:
          </InputLabel>
        </MuiGrid>
        <MuiGrid item md={6}>
          <MuiSelect
            variant="standard"
            name="isCyberIncident"
            {...register('isCyberIncident')}
            onChange={onSelect}
            defaultValue={getValues().isCyberIncident}
          >
            {yesNoOptions.map(({ label, value }) => (
              <MuiMenuItem key={label} value={value}>
                {label}
              </MuiMenuItem>
            ))}
          </MuiSelect>
        </MuiGrid>

        <MuiGrid item md={6}>
          <InputLabel inline htmlFor="isRemediationServiceBegun">
            Have remediation services already begun?:
          </InputLabel>
        </MuiGrid>
        <MuiGrid item md={6}>
          <MuiSelect
            variant="standard"
            name="isRemediationServiceBegun"
            {...register('isRemediationServiceBegun')}
            onChange={onSelect}
            defaultValue={getValues().isRemediationServiceBegun}
          >
            {yesNoOptions.map(({ label, value }) => (
              <MuiMenuItem key={label} value={value}>
                {label}
              </MuiMenuItem>
            ))}
          </MuiSelect>
        </MuiGrid>

        <MuiGrid item md={6}>
          <InputLabel inline htmlFor="otherInformationExplanation">
            If yes, please explain:
          </InputLabel>
        </MuiGrid>
        <MuiGrid item md={6}>
          <TextField
            name="otherInformationExplanation"
            controllerProps={{ control }}
            fullWidth
            multiline
            minRows="4"
          />
        </MuiGrid>
      </MuiGrid>
    </MuiCard>
  );
});

const yesNoOptions = [
  { label: 'Yes', value: 'yes' },
  { label: 'No', value: 'no' },
];
